import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { UserGroupMemberFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';

import * as yup from 'yup';

/** User group create/update request body */
export interface UserGroupFormInterface {
  /** Display name */
  name: string;
  /** Participant users */
  users: UserGroupMemberFindInterface[];
}

/** User group create/update request body - DTO schema */
export const UserGroupFormDto = SerdeDtoClass.create<UserGroupFormInterface>(SecurityDtoKeysEnum.USER_GROUP_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  users: {
    label: 'Участники',
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
    serializer: <yup.Schema>yup.array(yup.object({
      id: yup.number(),
      isSupervisor: yup
        .boolean()
        .notRequired()
        .default(false),
    })),
  },
})
